function getSizeOptionValue(width: number, height: number) {
  return `${width} ${height}`;
}

export default getSizeOptionValue;
